export const hasScroll = element => {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};
export const scrollableParent = element => {
  return element ? hasScroll(element) ? element : scrollableParent(element.parentElement) : null;
};
export const elementViewportOrigin = element => {
  const rect = element.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) * 100 / window.innerWidth;
  const y = (rect.top + rect.height / 2) * 100 / window.innerHeight;
  return `${x}% ${y}%`;
};